(() => {
  const cleanVariantLabel = (value) => value
    .replace(/\s+Womens\b/gi, '')
    .replace(/\s*PREORDER\s*[·|-]\s*EARLY TO MID-NOVEMBER/gi, ' — preorder')
    .replace(/\s*\/\s*/g, ' / ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  const enhanceBundle = (root) => {
    if (!(root instanceof HTMLElement)) return;

    const title = root.querySelector('.Vtl-ProductBundleWidget__BundleTitle');
    if (title && title.textContent !== 'Complete her cosy wardrobe') {
      title.textContent = 'Complete her cosy wardrobe';
    }

    const toggle = root.querySelector('.Vtl-ProductBundleWidget__SeeLessBtn[aria-expanded="false"]');
    if (toggle instanceof HTMLElement) toggle.click();

    root.querySelectorAll('.Vtl-Dropdown__Header-Selected').forEach((label) => {
      const clean = cleanVariantLabel(label.textContent || '');
      if (clean && label.textContent !== clean) label.textContent = clean;
      label.setAttribute('title', clean);
    });

    const price = root.querySelector('.Vtl-BundleSummary__CurrentPrice')?.textContent?.trim();
    const button = root.querySelector('.Vtl-UBBundleBoxAtcButton');
    const buttonText = button?.querySelector('.Vtl-Button__Text');
    if (button && buttonText && price) {
      const label = `Add both — ${price}`;
      if (buttonText.textContent !== label) buttonText.textContent = label;
      button.setAttribute('aria-label', label);
    }
  };

  const enhanceAddOns = () => {
    const section = document.querySelector('#vitals-end-section');
    const productInfo = document.querySelector('[id^="product-info-"]');
    const productForm = productInfo?.querySelector('product-form');

    if (section && productForm?.parentElement && section.nextElementSibling !== productForm) {
      productForm.parentElement.insertBefore(section, productForm);
    }

    const title = section?.querySelector('.Vtl-UpsellBuilderProductAddOn__Title');
    if (title && title.textContent !== 'Add a little extra') title.textContent = 'Add a little extra';
  };

  let scheduled = false;
  const run = () => {
    scheduled = false;
    document.querySelectorAll('.Vtl-ProductBundleWidget__BundleWrapper').forEach(enhanceBundle);
    enhanceAddOns();

    document.querySelectorAll('.variant-picker__option .select span[id$="-selected-value"], .Vtl-Dropdown__Header-Selected').forEach((label) => {
      const clean = cleanVariantLabel(label.textContent || '');
      if (clean && label.textContent !== clean) label.textContent = clean;
      label.setAttribute('title', clean);
    });
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  };

  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();
